import { PublicKey } from "@solana/web3.js";
const TOKEN_PROGRAM_ID = new PublicKey("TokenAAGbeQq5tGW2r5RoR3oauzN2EkNFiHNPw9q34s");
const ASSOCIATED_PROGRAM_ID = new PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
export async function associatedAddress({ mint, owner, }) {
    return (await PublicKey.findProgramAddress([owner.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()], ASSOCIATED_PROGRAM_ID))[0];
}
//# sourceMappingURL=token.js.map